<template>
  <!--试题-->
  <div class="testList">
    <div
      v-for="(item, index) in jsonData"
      :key="index"
      class="test_wrap"
      :class="{img_border :questionrow.questionType}"
    >
      <div slot="header" class="clearfix">
        <!--文字标题-->
        <div class="test_title" v-if="questionrow.questionType==0">
          <div style="font-size:16px;margin-bottom:20px;" v-if="!item.Group">{{index+1}}、{{item.description}}</div>
          <div style="font-size:16px" v-else>
            <div>{{index+1}}、{{item.Group}}</div>
            <div style="color:red">{{item.description}}</div>
          </div>
        </div>
        <!--图片标题-->
        <div class="img_title" style="background:#fff" v-else>
          <span>{{index+1}}、</span>
          <el-image style="width: 250px; height: 150px" :src="item.description" fit="contain"></el-image>
        </div>
      </div>
      <!--选项组-->
      <el-radio-group v-model="item.checkOptionId">
        <div
          v-for="(subItem,subIndex) in item.scaleQuestionOptions"
          :key="subIndex"
          :class="{img_warp:questionrow.questionType}"
        >
          <!--文字选项-->
          <div v-if="questionrow.questionType==0">
            <el-radio disabled style="height:30px;" checked='true' :label="subItem.optionId">{{subItem.description}}</el-radio>
			

            <!--这是添加的-->
            <div class="subTtemquestion" v-if="subItem.RelationQuestion&&subItem.RelationQuestion.length>0">
              <div v-for="(subItemlist,subItemindex) in subItem.RelationQuestion"  :key="subItemindex" class="abc">
                 <div class="subTtemquestionItem" >({{subItemindex+1}})、{{subItemlist.Title}}</div>
                  
             <el-radio-group v-model="subItemlist.checkOptionId">
                <p  v-for="(subItemlistItem,subItemlistItemIndex) in subItemlist.Options" :key="subItemlistItemIndex">
                  <el-radio disabled :label="subItemlistItem.OptionsID">{{subItemlistItem.Content}}</el-radio>
                </p>
              </el-radio-group>
            </div>
              </div>
          </div>

          <!--图片选项-->
          <div class="img_box" v-else>
            <el-radio disabled style="height:55px;" :label="subItem.optionId" >
              <el-image style="width: 95px; height: 55px" :src="subItem.description" lazy></el-image>
            </el-radio>
          </div>
        </div>
      </el-radio-group>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    jsonData: {
      default: []
    },
	questionrow:{
		default:{}
	} //默认题型为纯文字题
  },
};
</script>
<style lang="less" scoped>
.subTtemquestion {
  margin-left:20px;
p{
    height: 24px;
}
}
.abc{
    margin-top: 16px;
}
.subTtemquestionItem {
  font-size: 13px;
 
}
.testList {
  padding-left: 20px;
  height: 500px;
  overflow-y:auto;
}

.test_wrap {
  margin: 20px 0;
  font-size: 16px;
  color: #222;
}

.img_border {
  border-bottom: 1px solid #ddd;
}

.img_warp {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  display: inline-block;
  width: 33%;

  .img_box {
    display: flex;
    align-items: center;
    margin: 30px 0;
    padding-left: 30px;
  }
}
 /deep/.el-radio__input.is-disabled+span.el-radio__label{
  color: #676767 !important;
}
/deep/.el-radio__input.is-checked+span.el-radio__label{
  color:  #091d7c !important;
}
</style>



// WEBPACK FOOTER //
// src/components/TestList.vue